import { Flex, Icon, IconButton, Input, InputGroup, InputRightElement, Tooltip } from '@chakra-ui/react';
import { useState } from 'react';
import { MdAutorenew, MdVisibility, MdVisibilityOff } from 'react-icons/md';
import { generateStrongPassword } from '../../services/password.service';
import { toastService } from '../../services/toast.service';

interface PasswordInputProps {
	value: string;
	onChange: (value: string) => void;
	placeholder?: string;
	// Campo de senha ATUAL não deve oferecer gerador — só os de senha nova.
	withGenerator?: boolean;
}

export default function PasswordInput({ value, onChange, placeholder, withGenerator = true }: PasswordInputProps) {
	const [show, setShow] = useState(false);

	const handleGenerate = async () => {
		const generated = generateStrongPassword();
		onChange(generated);
		// Revela o campo: senha gerada que ninguém consegue ler é inútil.
		setShow(true);
		try {
			await navigator.clipboard.writeText(generated);
			toastService.success('Senha gerada e copiada');
		} catch {
			// clipboard exige contexto seguro (https/localhost); fora disso o
			// usuário ainda consegue ler e copiar na mão.
			toastService.success('Senha gerada');
		}
	};

	const paddingRight = withGenerator ? '80px' : '44px';

	return (
		<InputGroup>
			<Input
				variant='main'
				type={show ? 'text' : 'password'}
				value={value}
				placeholder={placeholder}
				pr={paddingRight}
				onChange={e => onChange(e.target.value)}
			/>
			<InputRightElement width={paddingRight} justifyContent='flex-end' pe='8px'>
				<Flex gap='2px'>
					<Tooltip label={show ? 'Ocultar' : 'Mostrar'} fontSize='xs'>
						<IconButton
							aria-label={show ? 'Ocultar senha' : 'Mostrar senha'}
							icon={<Icon as={show ? MdVisibilityOff : MdVisibility} w='16px' h='16px' />}
							size='xs'
							variant='ghost'
							onClick={() => setShow(!show)}
						/>
					</Tooltip>
					{withGenerator && (
						<Tooltip label='Gerar senha forte' fontSize='xs'>
							<IconButton
								aria-label='Gerar senha forte'
								icon={<Icon as={MdAutorenew} w='16px' h='16px' />}
								size='xs'
								variant='ghost'
								color='brand.500'
								onClick={handleGenerate}
							/>
						</Tooltip>
					)}
				</Flex>
			</InputRightElement>
		</InputGroup>
	);
}
